var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-tree',{attrs:{"props":_vm.props,"load":_vm.loadNode,"node-key":"dicValue","default-expanded-keys":[1],"draggable":"","lazy":""},on:{"node-click":_vm.handleNodeClick}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }